import { GetToken, LogOut, SetClientID, TokenDetails } from "@zerolight-core/zl-auth-handler";
import { useState } from "react";

export async function getTokenInfo(clientId: string, scope: string[]){
    SetClientID(clientId);
    try {
        return await GetToken(scope);
    }
    catch (ex) {
        console.error("Failed to get a token", ex)
        LogOut()
        window.location.reload()
    }
}
let tokenPromise: Promise<TokenDetails | undefined>;

export function setupAuth(tokenRequest: { clientID: string, scope: string[] })
{
    tokenPromise = getTokenInfo(tokenRequest.clientID, tokenRequest.scope);
}

export function useToken()
{
    const [token, setToken] = useState<string | undefined>(undefined);
    if (!tokenPromise)
        return {};

    tokenPromise.then(r => r?.token != token && setToken(r?.token));
    return (token && { token }) ?? undefined;
}

export function requireToken(service: string) {
    return service !== "slatelive"
}